// Configuration for different environments - ALWAYS use direct backend URLs
const config = {
  development: {
    API_BASE_URL: 'http://localhost:5000/api', // Local backend for development
  },
  production: {
    API_BASE_URL: 'https://changemanagement-backend-ahfre3hvgcerbrgp.canadacentral-01.azurewebsites.net/api', // Direct Azure backend
  }
};

// Determine current environment
const environment = process.env.NODE_ENV || 'development';

// Export the appropriate config
export default config[environment]; 